var render = function render() {
  var _vm = this,
    _c = _vm._self._c;
  return _c("div", [_c("a-modal", {
    attrs: {
      visible: _vm.functionalVisible,
      title: _vm.$t("功能配置"),
      okText: _vm.$t("关闭"),
      width: 1000,
      maskClosable: false,
      cancelButtonProps: {
        style: {
          display: "none"
        }
      },
      wrapClassName: "functional-configuration-class"
    },
    on: {
      ok: function ($event) {
        return _vm.$emit("update:functionalVisible", false);
      },
      cancel: function ($event) {
        return _vm.$emit("update:functionalVisible", false);
      }
    }
  }, [_c("div", {
    staticStyle: {
      height: "600px",
      overflow: "auto"
    }
  }, [_c("a-tabs", {
    attrs: {
      tabPosition: "left",
      activeKey: _vm.activeKey
    },
    on: {
      change: _vm.tabChange
    }
  }, [_c("a-tab-pane", {
    key: "all",
    attrs: {
      tab: _vm.$t("全部")
    }
  }, [_c("a-input-search", {
    staticStyle: {
      "margin-bottom": "20px"
    },
    attrs: {
      placeholder: _vm.$t("请输入") + _vm.$t("查询内容"),
      "enter-button": ""
    },
    on: {
      search: _vm.onSearch
    },
    model: {
      value: _vm.searchMarkKey,
      callback: function ($$v) {
        _vm.searchMarkKey = $$v;
      },
      expression: "searchMarkKey"
    }
  }), _c("a-select", {
    staticStyle: {
      width: "100%",
      "margin-bottom": "20px"
    },
    attrs: {
      placeholder: _vm.$t("请选择") + _vm.$t("关联数据源"),
      allowClear: ""
    },
    model: {
      value: _vm.associateDataSource,
      callback: function ($$v) {
        _vm.associateDataSource = $$v;
      },
      expression: "associateDataSource"
    }
  }, [_c("a-select-option", {
    attrs: {
      value: "system"
    }
  }, [_vm._v(_vm._s(_vm.$t("系统内置")))]), _c("a-select-option", {
    attrs: {
      value: "dynamic"
    }
  }, [_vm._v(_vm._s(_vm.$t("动态获取")))]), _c("a-select-option", {
    attrs: {
      value: "filter"
    }
  }, [_vm._v(_vm._s(_vm.$t("筛选项")))])], 1), _c("a-cascader", {
    staticStyle: {
      width: "100%",
      "margin-bottom": "20px"
    },
    attrs: {
      options: _vm.dataSourceComputed,
      placeholder: _vm.$t("请手动关联数据源"),
      popupClassName: "cascader-relation-function-config"
    },
    on: {
      change: (e, selectedOptions) => _vm.onMarkChange(e, selectedOptions)
    },
    scopedSlots: _vm._u([{
      key: "displayRender",
      fn: function ({
        labels,
        selectedOptions
      }) {
        return _vm._l(labels, function (label, index) {
          return _c("span", {
            key: selectedOptions[index].id
          }, [_vm._v(_vm._s(typeof label === "object" ? label.data.attrs.value : label + "/") + " ")]);
        });
      }
    }])
  }, [_c("el-input", {
    attrs: {
      placeholder: _vm.$t("请手动关联数据源")
    },
    model: {
      value: _vm.input,
      callback: function ($$v) {
        _vm.input = $$v;
      },
      expression: "input"
    }
  })], 1), _c("div", {
    staticClass: "search-list-container"
  }, _vm._l(_vm.markList, function (item, i) {
    return _c("div", {
      key: item.mark + item.title + i
    }, [item.lastText ? _c("span", _vm._l(item.title.split("/"), function (text, index) {
      return _c("span", {
        key: item.mark + item.title + index
      }, [_vm._v(" " + _vm._s(_vm.$t(text) + "/") + " ")]);
    }), 0) : _vm._e(), item.lastText && item.lastText.indexOf(_vm.searchMarkKey) !== -1 ? _c("span", [_vm._v(" " + _vm._s(item.lastText.slice(0, item.lastText.indexOf(_vm.searchMarkKey)))), _c("span", {
      staticClass: "main-text-Color"
    }, [_vm._v(_vm._s(_vm.searchMarkKey))]), _vm._v(_vm._s(item.lastText.slice(item.lastText.indexOf(_vm.searchMarkKey) + _vm.searchMarkKey.length)) + " ")]) : _c("span", [_vm._v(_vm._s(item.lastText))]), item.lastText ? _c("svg-icon", {
      staticClass: "copy-icon",
      attrs: {
        icon: "copy",
        size: 20
      },
      nativeOn: {
        click: function ($event) {
          return _vm.copyMark(item);
        }
      }
    }) : _vm._e()], 1);
  }), 0)], 1), _c("a-tab-pane", {
    key: "dataContainer",
    attrs: {
      tab: _vm.$t("数据容器")
    }
  }, [_c("a-input-search", {
    attrs: {
      placeholder: _vm.$t("请输入") + _vm.$t("查询内容"),
      "enter-button": ""
    },
    on: {
      search: _vm.onTableSearch
    },
    model: {
      value: _vm.searchTableKey,
      callback: function ($$v) {
        _vm.searchTableKey = $$v;
      },
      expression: "searchTableKey"
    }
  }), _c("div", {
    staticClass: "table-list-container"
  }, _vm._l(_vm.tableList, function (item, index) {
    return _c("div", {
      key: item.mark + item.name,
      staticClass: "table-item"
    }, [_c("a-tag", {
      staticClass: "tag-class"
    }, [_vm._v(_vm._s(item.name + ": " + item.mark) + " "), _c("svg-icon", {
      staticClass: "copy-icon marginR10",
      attrs: {
        icon: "copy",
        size: 20
      },
      nativeOn: {
        click: function ($event) {
          return (e => _vm.copyTableMark(e, item)).apply(null, arguments);
        }
      }
    }), _c("a-popover", {
      attrs: {
        trigger: "hover",
        destroyTooltipOnHide: true,
        placement: "bottomLeft"
      },
      scopedSlots: _vm._u([{
        key: "content",
        fn: function () {
          return [_c("tableItem", {
            attrs: {
              index: index,
              data: item
            }
          })];
        },
        proxy: true
      }], null, true)
    }, [_c("a-icon", {
      style: {
        fontSize: "20px",
        marginLeft: "10px"
      },
      attrs: {
        type: "question-circle"
      },
      on: {
        click: function ($event) {
          return _vm.changeTag(item);
        }
      }
    })], 1)], 1)], 1);
  }), 0)], 1), _c("a-tab-pane", {
    key: "quickConfigurationEnter",
    attrs: {
      tab: _vm.$t("快捷入口")
    }
  })], 1)], 1)]), _vm.configVisiable ? _c("quick-configuration-modal", {
    attrs: {
      configVisiable: _vm.configVisiable,
      type: "quick"
    },
    on: {
      "update:configVisiable": function ($event) {
        _vm.configVisiable = $event;
      },
      "update:config-visiable": function ($event) {
        _vm.configVisiable = $event;
      },
      close: _vm.closeQuickConfiguration
    }
  }) : _vm._e()], 1);
};
var staticRenderFns = [];
render._withStripped = true;
export { render, staticRenderFns };